import * as React from "react";
import { useReducer, useContext } from "react";
const SelectedRowsContext = React.createContext(null);
const SelectedRowsDispatchContext = React.createContext(null);
function selectedRowsReducer(state, action) {
  const uniqueIdKey = action.type !== "clear" ? action.key || "id" : void 0;
  switch (action.type) {
    case "update":
      return state.map((stateRow) => {
        if (stateRow[uniqueIdKey] === action.payload[uniqueIdKey]) return action.payload;
        return stateRow;
      });
    case "add":
      return [
        ...state,
        ...action.payload.filter(
          (payloadRow) => !state.find((stateRow) => stateRow[uniqueIdKey] === payloadRow[uniqueIdKey])
        )
      ];
    case "remove":
      return state.filter(
        (stateRow) => !action.payload.find((payloadRow) => stateRow[uniqueIdKey] === payloadRow[uniqueIdKey])
      );
    case "upsert":
      return [...action.payload];
    case "clear":
      return [];
    default:
      return state;
  }
}
export function SelectedRowsProvider({ children }) {
  const [state, dispatch] = useReducer(selectedRowsReducer, []);
  return /* @__PURE__ */ React.createElement(SelectedRowsContext.Provider, { value: state }, /* @__PURE__ */ React.createElement(SelectedRowsDispatchContext.Provider, { value: dispatch }, children));
}
export function useSelectedRows() {
  const context = useContext(SelectedRowsContext);
  if (context === null) console.error("No Selected Rows provider found.");
  return context;
}
export function useSelectedRowsDispatch() {
  const context = useContext(SelectedRowsDispatchContext);
  if (context === null) console.error("No Selected Rows provider found.");
  return context;
}
